import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const colorApi = createApi({
  reducerPath: 'colorApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Color'],
  endpoints: (builder) => ({
    getColors: builder.query({
      query: (page = 1) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/color',
          method: 'GET',
          params: { page, 'access-token': token },
        };
      },
      providesTags: ['Color'],
    }),
    addColor: builder.mutation({
      query: (formData) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/add-color',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      invalidatesTags: ['Color'],
    }),
    updateColor: builder.mutation({
      query: (formData) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/update-color',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      invalidatesTags: ['Color'],
    }),
    deleteColor: builder.mutation({
      query: (formData) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/delete-color',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      invalidatesTags: ['Color'],
    }),
  }),
});

export const {
  useGetColorsQuery,
  useAddColorMutation,
  useUpdateColorMutation,
  useDeleteColorMutation,
} = colorApi;
